import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  message: string;
  onClose: () => void;
  durationMs?: number;
}

/** Fixed bottom toast — auto-dismiss after duration. */
export function NmToast({ message, onClose, durationMs = 2800 }: Props) {
  useEffect(() => {
    const id = window.setTimeout(onClose, durationMs);
    return () => window.clearTimeout(id);
  }, [message, onClose, durationMs]);

  return createPortal(
    <div className="nm-toast" role="status" aria-live="polite">
      {message}
    </div>,
    document.body,
  );
}
